import React from 'react';
import { BookOpen, Grid, FileSignature, Settings, BookType } from 'lucide-react';
import { Card } from './ui/Card';
export function ProductBundle() {
  const items = [{
    icon: <BookOpen className="h-8 w-8 text-[#00d4aa]" data-id="element-189" />,
    title: 'El eBook Principal',
    desc: "Guía paso a paso de 'Gamer a Creador' (PDF). Todo el sistema explicado en lenguaje sencillo."
  }, {
    icon: <Grid className="h-8 w-8 text-[#f59e0b]" data-id="element-190" />,
    title: 'La Matriz Gamer-Coder',
    desc: 'Para saber exactamente por dónde debe empezar tu hijo según su personalidad y tipo de juegos favoritos.'
  }, {
    icon: <FileSignature className="h-8 w-8 text-blue-500" data-id="element-191" />,
    title: 'El Contrato de Creador',
    desc: 'Un acuerdo listo para imprimir que elimina las peleas por el tiempo de pantalla estableciendo reglas claras.'
  }, {
    icon: <Settings className="h-8 w-8 text-purple-500" data-id="element-192" />,
    title: 'Guía de Configuración',
    desc: 'Cómo instalar los motores de juego profesionales en menos de 10 minutos sin virus ni complicaciones.'
  }, {
    icon: <BookType className="h-8 w-8 text-pink-500" data-id="element-193" />,
    title: 'Glosario Gamer para Padres',
    desc: 'Para que por fin entiendas de qué habla tu hijo (AFK, NPC, Lag, Mod) y puedas guiarlo.'
  }];
  return <section className="py-20 bg-[#0a0e1a]" data-id="element-194">
      <div className="container mx-auto px-4" data-id="element-195">
        <div className="text-center mb-12" data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-197">
            Todo lo que recibes hoy
          </h2>
          <p className="text-gray-400" data-id="element-198">
            Un paquete completo de herramientas para la transformación digital
            de tu familia.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-199">
          {items.map((item, idx) => <Card key={idx} hoverEffect className="flex flex-col h-full bg-[#111827]" data-id="element-200">
              <div className="mb-4 p-3 bg-gray-800/50 rounded-lg w-fit" data-id="element-201">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-202">
                {item.title}
              </h3>
              <p className="text-gray-400 flex-grow" data-id="element-203">{item.desc}</p>
            </Card>)}
        </div>
      </div>
    </section>;
}